import React from 'react'
import ClientSuspense from '@components/ClientSuspense'
import useSections from '@page-components/CheckoutV3/hooks/useSections'

import CustomFieldsModal from './CustomFieldsModal'

const CustomFieldsWithSectionFilter = () => {
  const sections = useSections()
  if (!sections.includes('customFields')) return null

  return <CustomFieldsModal />
}

export default function CustomFieldsWrapper() {
  return (
    <ClientSuspense fallback={null}>
      <CustomFieldsWithSectionFilter />
    </ClientSuspense>
  )
}
